import {
  Box,
  Button,
  ComboboxData,
  FileInput,
  Group,
  LoadingOverlay,
  NumberInput,
  rem,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconFileCv } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { createArticleCategory } from "../../../api/ApiArticle";
import ButtonClose from "../../../common/ButtonClose/ButtonClose";
import QuillEditor from "../../../common/QuillEditor";
import { ArticleCategory } from "../../../model/Article";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { uploadFile } from "../../../api/ApiProduct";
import ImageShow from "../../../_base/component/_image";

const ShowType = [
  // { value: "1", label: "Chỉ hiển thị danh mục con" },
  // { value: "2", label: "Chỉ hiển thị bài" },
  // { value: "3", label: "Hiển thị bài + Danh mục con " },
  { value: "child_only", label: "Chỉ hiển thị danh mục con" },
  { value: "article", label: "Chỉ hiển thị bài" },
  { value: "child_article", label: "Hiển thị bài + Danh mục con " },
];

const CreateView = ({ onSearch, datas }: any) => {
  const entity: ArticleCategory = {
    name: "",
    code: "",
    linkIndex: "",
    description: "",
    imageUrl: null,
    parentId: null,
    status: null,
    type: "article", // mặc đinh type là article
    orderNumber: null,
    creationDate: "",
    createdBy: "",
    lastUpdateDate: "",
    lastUpdatedBy: "",
    metaTitle: "",
    metaKeyword: "",
    metaDescription: "",
    note: "",
    url: "", // link bài viết
    displayOption: "",
    requestPath: "",
  };
  const icon = (
    <IconFileCv style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );
  const handleChangeDatadescription = (description: string | null) => {
    let modifiedString = description?.replace(
      /src="\/media/g,
      'src="https://hanoicomputercdn.com/media'
    );
    return modifiedString ? modifiedString : "";
  };

  const handleCreateArticleCategory = async (dataSubmit: ArticleCategory) => {
    // Gán code bằng url
    dataSubmit.code = dataSubmit.url || "";
    dataSubmit.description = valueDescription || "";

    // Tự sinh requestPath từ url (có dấu / đằng trước)
    if (dataSubmit.url) {
      dataSubmit.requestPath = dataSubmit.url.startsWith("/")
        ? dataSubmit.url
        : `/${dataSubmit.url}`;
    } else {
      dataSubmit.requestPath = "";
    }

    console.log("dataSubmit after processing:", dataSubmit);
    await createArticleCategory(dataSubmit);
    onSearch();
    modals.closeAll();
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [valueDescription, setValueDescription] = useState();

  // Hàm xử lý upload ảnh
  const handleChangeImage = async (file: File | null) => {
    console.log("file", file);

    if (!file) {
      // Nếu user xóa file (clear)
      form.setFieldValue("imageUrl", null);
      return;
    }

    try {
      open(); // Hiện loading

      // Upload file
      const response = await uploadFile([file]);

      if (
        response &&
        response.success &&
        response.data &&
        response.data.length > 0
      ) {
        const uploadedUrl = response.data[0]?.url;
        form.setFieldValue("imageUrl", uploadedUrl);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      NotificationExtension.Fails("Upload ảnh thất bại!");
    } finally {
      close(); // Tắt loading
    }
  };

  const [dataOption, setDataOption] = useState<ComboboxData>();
  useState<ArticleCategory[]>();

  const form = useForm<ArticleCategory>({
    initialValues: {
      ...entity,
    },
    validate: {
      // code: (value: string | null) => {
      //   return !value || /^\s*$/.test(value)
      //     ? "Mã Danh Mục Bài Viết chưa nhập"
      //     : value.length > 50
      //     ? "Mã Danh Mục Bài Viết không được vượt quá 50 ký tự"
      //     : // : !/^[a-zA-Z0-9\sàáạãảăắằẳẵặâầấẩẫậèéẹẽẻêềếểễệđìíịĩỉòóọõỏôồốổỗộơờớởỡợùúụũủưừứửữựỳýỵỹỷ]+$/u.test(
      //       //   value
      //       // )
      //       // ? "Tên Danh Mục Bài Viết không được chứa kí tự đặc biệt"
      //       // : !/^\d+$/.test(value)
      //       // ? "Mã Danh Mục Bài Viết chỉ được nhập số"
      //       undefined;
      // },
      name: (value: string | null) => {
        return !value || /^\s*$/.test(value)
          ? "Tên Danh Mục Bài Viết chưa nhập"
          : // : !/^[a-zA-Z0-9\sàáạãảăắằẳẵặâầấẩẫậèéẹẽẻêềếểễệđìíịĩỉòóọõỏôồốổỗộơờớởỡợùúụũủưừứửữựỳýỵỹỷ]+$/u.test(
            //     value
            //   )
            // ? "Tên Danh Mục Bài Viết không được chứa kí tự đặc biệt"
            undefined;
      },

      // linkIndex: isNotEmpty("Link Index chưa nhập"),
      // imageUrl: isNotEmpty("URL ảnh chưa nhập"),
      // status: isNotEmpty("Trạng thái chưa nhập"),
      // type: isNotEmpty("Loại chưa nhập"),
      // orderNumber: isNotEmpty("Số thứ tự chưa nhập"),
      metaTitle: isNotEmpty("Tiêu đề meta chưa nhập"),
      metaKeyword: isNotEmpty("Từ khóa meta chưa nhập"),
      metaDescription: isNotEmpty("Mô tả meta chưa nhập"),
      // note: isNotEmpty("Ghi chú chưa nhập"),
      url: isNotEmpty("Link danh mục bài viết chưa nhập"),
    },
  });

  useEffect(() => {
    const dataOption = datas?.map((item: any) => {
      return { value: item?.id?.toString(), label: item?.name };
    });
    setDataOption(dataOption);
  }, [datas]);

  return (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={900}
        maw={900}
        mx="auto"
        onSubmit={form.onSubmit((values: ArticleCategory) => {
          handleCreateArticleCategory(values);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Tên danh mục bài viết"}
            placeholder={"Nhập tên"}
            withAsterisk
            mt="md"
            type="text"
            {...form.getInputProps("name")}
          />
          <Select
            label={"Trạng thái"}
            placeholder={"Trạng thái"}
            // withAsterisk
            mt="md"
            data={[
              { value: "Y", label: "Hoạt động" },
              { value: "N", label: "Không hoạt động" },
            ]}
            {...form.getInputProps("status")}
          />
        </Group>
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          {/* <TextInput
            label={"Mã danh mục bài viết"}
            placeholder={"Nhập mã"}
            withAsterisk
            mt="md"
            type="text"
            {...form.getInputProps("code")}
          /> */}
          <TextInput
            label={"Link danh mục bài viết"}
            placeholder={"Nhập link danh mục bài viết"}
            withAsterisk
            mt="md"
            type="text"
            {...form.getInputProps("url")}
          />
        </Group>
        <Group grow wrap="nowrap" gap={"lg"}>
          <FileInput
            leftSection={icon}
            label={"Ảnh cho danh mục"}
            placeholder={"Chọn ảnh"}
            accept="image/png,image/jpeg"
            clearable
            w={"50%"}
            mt="md"
            mb="md"
            key={form.key("imageUrl")}
            {...form.getInputProps("imageUrl")}
            onChange={handleChangeImage}
          />
          <div style={{ width: "50%" }}>
            {form.getValues().imageUrl && (
              <div>
                <ImageShow
                  h={200}
                  w={300}
                  img={form.getValues().imageUrl?.toString() ?? ""}
                />
              </div>
            )}
          </div>
        </Group>
        <Group grow wrap="nowrap" mt="md" gap={"lg"}>
          <TextInput
            label={"Tóm tắt"}
            placeholder={"Nhập tóm tắt"}
            // withAsterisk
            mt="md"
            type="text"
            {...form.getInputProps("note")}
          />
        </Group>

        <Text size="sm" mt="sm" fw={500}>
          Mô tả chi tiết (nếu có)
        </Text>
        {/* <QuillEditor
          toolbarId="t1"
          setValue={setValue}
          onChangeValue={(html: string) =>
            (form.values.description = handleChangeDatadescription(html))
          }
          description={handleChangeDatadescription(form.values.description)}
        /> */}
        <QuillEditor
          toolbarId="t1"
          setValue={setValueDescription}
          // onChangeValue={(html: string) =>
          //   (form.values.content = handleChangeDataContent(html))
          // }
          description={handleChangeDatadescription(
            form.getValues().description
          )}
        />
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          {/* <TextInput
            label={"Link ảnh đại diện"}
            placeholder={"Nhập link"}
            withAsterisk
            type="text"
            {...form.getInputProps("imageUrl")}
          /> */}

          <Select
            mt={"lg"}
            label="Là danh mục con của :"
            placeholder="Chọn danh mục cha"
            data={dataOption}
            searchable
            {...form.getInputProps("parentId")}
            mb={"lg"}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <Select
            mt={"lg"}
            label="Loại nội dung hiển thị"
            placeholder=""
            data={ShowType}
            searchable
            // withAsterisk
            {...form.getInputProps("displayOption")}
            mb={"lg"}
          />
          <NumberInput
            label={"Thứ tự xuất hiện (cao xếp trước)"}
            placeholder={""}
            // withAsterisk
            {...form.getInputProps("orderNumber")}
          />
        </Group>

        <Text size="sm" mt="sm" fw={700}>
          Dùng cho SEO
        </Text>

        <TextInput
          label={"Meta Title"}
          placeholder={""}
          withAsterisk
          mt="md"
          type="text"
          {...form.getInputProps("metaTitle")}
        />
        <TextInput
          label={"Meta Keyword"}
          placeholder={""}
          withAsterisk
          mt="md"
          type="text"
          {...form.getInputProps("metaKeyword")}
        />
        <TextInput
          label={"Meta Description"}
          placeholder={""}
          withAsterisk
          mt="md"
          type="text"
          {...form.getInputProps("metaDescription")}
        />

        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color="#3598dc"
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
          <ButtonClose />
        </Group>
      </Box>
    </>
  );
};

export default CreateView;
